import { personasHttp } from '@/lib/api/personas-client';
import { PersonasService } from '@inference.engine/persona-api-client';

export const deletePersona = async (id: string, workspaceId: string): Promise<void> => {
  await PersonasService.delete({
    client: personasHttp,
    throwOnError: true,
    headers: { 'x-selected-workspace-id': workspaceId },
    path: { id },
  });
};
